export default __webpack_public_path__ + "static/media/ellipses-icon.37dd87d7.svg";